<template>
  <div v-loading="loading">
    <div class="header-btn">
      <el-button icon="el-icon-plus" size="small" type="warning" @click="openCreate"/>
    </div>

    <el-table
        :data="data"
        class="data-table"
        stripe
        style="width: 100%"
        @row-click="openEdit">
      <el-table-column
          v-for="item in  [
                      {label:'Title',prop:'title',wth:'450px'},
                      {label:'Publisher',prop:'publisher'},
                      {label:'Publish Date',prop:'publishDate',fmt:selfTimeFormat},
                      {label:'End Date',prop:'endDate',fmt:selfTimeFormat},
                      {label:'Last updated',prop:'updated',fmt:selfTimeFormat},
                     ]"
          :key="item.prop"
          :width="item.wth"
          :formatter="item.fmt"
          :label="item.label"
          :prop="item.prop">
      </el-table-column>
    </el-table>

    <div class="page">
      <el-pagination v-if="page.total>1"
                     @current-change="loadData"
                     :page-size="page.size"
                     :current-page.sync="page.page"
                     :page-count="page.totalPage"
                     layout="prev, pager, next"
                     :total="data.total">
      </el-pagination>
    </div>

    <el-dialog
        v-if="showEditDialog"
        :close-on-click-modal="false"
        :visible.sync="showEditDialog"
        center
        width="40%">
      <el-form ref="form" :model="form" label-position="left" label-width="140px">
        <el-form-item label="Type" prop="type" required>
          <el-radio-group v-model="form.type">
            <el-radio :label="1">Text Content</el-radio>
            <el-radio :label="2">Full Image Page</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="Title" prop="title" required>
          <el-input v-model="form.title" placeholder="Enter title"></el-input>
        </el-form-item>

        <el-form-item label="Publisher" prop="publisher" required>
          <el-input v-model="form.publisher" placeholder="Enter publisher"></el-input>
        </el-form-item>

        <el-form-item label="Content" prop="content">
          <el-input v-model="form.content" :autosize="{ minRows: 2 }" placeholder="Enter the content"
                    type="textarea"></el-input>
        </el-form-item>

        <el-form-item label="Publish Date" prop="publishDate" required>
          <el-date-picker v-model="form.publishDate" format="dd MMM yyyy HH:mm" placeholder="Pick a date"
                          type="datetime" value-format="yyyy-MM-dd HH:mm"></el-date-picker>
        </el-form-item>

        <el-form-item label="End Date" prop="endDate" required>
          <el-date-picker v-model="form.endDate" format="dd MMM yyyy HH:mm" placeholder="Pick a date"
                          type="datetime" value-format="yyyy-MM-dd HH:mm"></el-date-picker>
        </el-form-item>

        <!--                <el-form-item label="Files" v-if="form.uploadType === 'File'">-->
        <!--                    <file-uploader :uploaded-files.sync="form.files"></file-uploader>-->
        <!--                </el-form-item>-->

        <el-form-item label="Images">
          <image-uploader :emit-file-object="true" :updated-files.sync="form.files"></image-uploader>
        </el-form-item>

      </el-form>

      <span slot="footer" class="dialog-footer">
          <el-button type="primary" size="medium" @click="save">Save</el-button>
          <el-button type="danger" size="medium" v-if="!isCreate" @click="deleteItem(form.id)">Delete</el-button>
          <el-button @click="showEditDialog = false" size="medium">Cancel</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {pageRequest} from "@/utils/ApiUtils";
import {createNews, deleteNews, newsList, updateNews} from "@/api/BulletinAPI";
import ImageUploader from "../../../components/ImageUploader";

export default {
  name: "News",
  components: {ImageUploader},
  data() {
    return {
      data: [],
      loading: false,
      form: {},
      isCreate: false,
      showEditDialog: false,
      page: {'page': 1, 'size': 10, 'totalPage': 1, 'total': 0}
    }
  },
  methods: {
    loadData() {
      pageRequest(this, newsList)
    },
    openCreate() {
      this.form = {files: []}
      this.showEditDialog = true
      this.isCreate = true
    },
    openEdit(row) {
      const  copy = JSON.parse(JSON.stringify(row))
      if (!copy.files) {
          copy.files = []
      }else {
          copy.files.sort((o1,o2)=>o1.id-o2.id)
      }
      this.form = copy
      this.isCreate = false;
      this.showEditDialog = true
    },
    save() {
      let action = null
      if (this.form.id) {
        action = updateNews
      } else {
        this.form.status = 1
        action = createNews
      }
      this.$refs.form.validate((valid) => {
        if (valid) {
          action(this.form)
              .then(() => {
                this.loadData()
                this.showEditDialog = false
                this.$message.success("Save Successfully!")
              })
        }
      })
    },
    deleteItem(id) {
      this.$deleteRequest(this, deleteNews, id)
      this.showEditDialog = false
      this.$message.success("Delete Successfully!")
    }
  },
  mounted() {
    this.loadData()
  }
}
</script>

<style scoped>

</style>
